import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    mapProp: 'map',
    name: '分析对象',
    type: 'AMAI_AO',
}
